<span class="status-badge" [ngClass]="getStatusClass()">
  <mat-icon *ngIf="icon" class="badge-icon">{{ icon }}</mat-icon>
  <span class="badge-label">{{ label }}</span>
</span>

